import { render, staticRenderFns } from "./UserTabLinks.vue?vue&type=template&id=e54901f8&"
import script from "./UserTabLinks.vue?vue&type=script&lang=js&"
export * from "./UserTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports